var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-2 ml-2",attrs:{"outlined":""},on:{"click":_vm.startEditor}},[_vm._v(" Dodaj zapis matematyczny")])}
var staticRenderFns = []

export { render, staticRenderFns }